import { SurveyType } from 'src/containers_v2/survey/store/model';
import IPagination from 'src/models/pagination';

export class FetchSurveyReportParams implements IPagination {
  page: number;
  pageSize: number;
  search: string; // mirrorId
  sort: string;
  mirrorType: string;
  content: string;
  from: string;
  to: string;
  gender: string;
  shopName: string;

  constructor(
    page: number = 1,
    pageSize: number = 20,
    search: string = '',
    sort: string = 'mirrorId|asc',
    mirrorType: string,
    content: string,
    from: string,
    to: string,
    gender: string,
    shopName: string
  ) {
    this.page = page;
    this.pageSize = pageSize;
    this.search = search;
    this.sort = sort;
    this.mirrorType = mirrorType;
    this.content = content;
    this.from = from;
    this.to = to;
    this.gender = gender;
    this.shopName = shopName;
  }

  toString() {
    return `page=${this.page}&size=${this.pageSize}&mirrorId=${this.search}&mirrorType=${this.mirrorType}&content=${this.content}&gender=${this.gender}&from=${this.from}&to=${this.to}&sort=${this.sort}&shopName=${this.shopName}`;
  }
}

export type SurveyReportPageResult = {
  data: SurveyType[];
  totalCount: number;
};

export type FiltersResult = {
  mirrorContent: { [key: number]: string };
  mirrorTypes: string[];
  mirrorIds: string[];
  shopNames: string[];
};
